import { cn } from "lib/utils";
import React from "react";

import logo from "assets/images/totem/logo.svg";

export const TotemHeader: React.FC = () => (
	<header
		className={cn(
			"absolute left-1/2 top-0 flex h-[100px] w-[600px] max-w-full -translate-x-1/2 items-center justify-between bg-white px-12 py-8 max-[639px]:h-[72px] max-[639px]:w-[85%] max-[639px]:px-6 max-[639px]:py-4",
		)}
	>
		<img
			src={logo}
			alt="Kemira"
			className={cn(
				"block h-[36px] w-[180px] max-[639px]:h-auto max-[639px]:w-[92px]",
			)}
		/>
		<span
			className={cn(
				"shrink-0 whitespace-nowrap font-sans text-[16px] font-bold tracking-[0.8px] text-[#45556C] max-[639px]:text-[7px] max-[639px]:tracking-[0.25px]",
			)}
		>
			CHECK-IN DO MOTORISTA
		</span>
	</header>
);
